import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Spinner, Toggle } from "@opendate-app/setlist";

const axios = require("axios");
const qs = require("qs");

const subheaderStyle = {
  color: "var(--sl-text-tertiary)",
  fontSize: "12px"
};

const campaignRowStyle = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
};

const campaignLeftHandStyle = {
  marginTop: "10px",
  marginBottom: "10px",
  maxWidth: "350px",
};

const campaignNameStyle = {
  color: "var(--sl-text-primary)",
  fontSize: "14px",
  fontWeight: "900",
};

const campaignDescriptionStyle = {
  color: "var(--sl-text-tertiary)",
  fontSize: "12px",
};

const hrStyle = {
  borderTop: "1px solid var(--sl-border-secondary)",
};

const CampaignsTab = ({
  csrfToken,
  team,
  venueOwnershipId,
  overridable,
  description = "Enable automatic campaigns for this event.",
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [campaignsLoaded, setCampaignsLoaded] = useState(false);
  const [campaignOverrides, setCampaignOverrides] = useState([]);
  const requestConfig = { headers: { "X-CSRF-TOKEN": csrfToken } };

  const getCampaigns = () => {
    const queryString = qs.stringify({
      q: {
        venue_ownership_id_eq: venueOwnershipId,
      }
    })

    axios.get("/teams/" + team.id + "/campaigns.json?" + queryString, requestConfig)
      .then(({data}) => {
        setCampaigns(data);
        setCampaignsLoaded(true);
        getCampaignOverrides();
      })
      .catch(_error => {
        toast.error("Could not load campaigns, please try again", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
        setIsLoading(false);
      });
  };

  const getCampaignOverrides = () => {
    const queryString = qs.stringify({
      q: {
        overridable_id_eq: overridable.id,
        overridable_type_eq: overridable.type,
      }
    });

    axios.get("/teams/" + team.id + "/campaign_overrides?" + queryString, requestConfig)
      .then(({data}) => {
        setCampaignOverrides(data);
        setIsLoading(false);
      })
      .catch(_error => {
        toast.error("Could not load campaign overrides, please try again", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
        setIsLoading(false);
      });
  };

  const createCampaignOverride = (campaign_id) => {
    axios.post("/teams/" + team.id + "/campaign_overrides", {
      overridable_id: overridable.id,
      overridable_type: overridable.type,
      campaign_id: campaign_id,
      disabled: true,
    }, requestConfig)
      .then(({data}) => {
        setCampaignOverrides([...campaignOverrides, data]);
        setIsSubmitting(false);
      })
      .catch(_error => {
        toast.error("Could not disable campaign, please try again", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
        setIsSubmitting(false);
      });
  };

  const toggleCampaignOverride = (override) => {
    axios.put("/teams/" + team.id + "/campaign_overrides/" + override.id, {
      disabled: !override.disabled,
    }, requestConfig)
      .then(({data}) => {
        setCampaignOverrides(campaignOverrides.map(campaignOverride => {
          if (campaignOverride.id === data.id) {
            return data;
          } else {
            return campaignOverride;
          }
        }));
        setIsSubmitting(false);
      })
      .catch(_error => {
        toast.error("Could not toggle campaign, please try again", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
        setIsSubmitting(false);
      });
  };

  const isCampaignEnabled = (campaign_id) => {
    const override = campaignOverrides.find(override => override.campaign_id === campaign_id);

    if (override) {
      return !override.disabled;
    } else {
      return true;
    }
  };

  const toggleCampaign = (campaign_id) => {
    setIsSubmitting(true);

    const override = campaignOverrides.find(override => override.campaign_id === campaign_id);

    if (override) {
      toggleCampaignOverride(override);
    } else {
      createCampaignOverride(campaign_id);
    }
  };

  useEffect(() => { getCampaigns(); }, []);

  return (
    <div>
      <div style={subheaderStyle}>
        {description}
      </div>
      {isLoading ? (
        <div className="mt-3">
          <Spinner size="sm" aria-label="Loading campaigns" />
        </div>
      ) : (
      <div>
        {campaignsLoaded && campaigns.length === 0 && (
          <p className="mt-3" style={campaignDescriptionStyle}>No automatic campaigns are set up for this venue.</p>
        )}
        {campaigns.map((campaign, index) => {
          return (
            <div key={campaign.id}>
              <div
                style={campaignRowStyle}
              >
                <div style={campaignLeftHandStyle}>
                  <div style={campaignNameStyle}>
                    {campaign.campaign_template.name}
                  </div>
                  <div style={campaignDescriptionStyle}>
                    {campaign.campaign_template.description}
                  </div>
                </div>
                <Toggle
                  id={`campaign-${campaign.id}-enabled`}
                  aria-label={campaign.campaign_template.name}
                  checked={isCampaignEnabled(campaign.id)}
                  disabled={isSubmitting}
                  onChange={() => toggleCampaign(campaign.id)}
                />
              </div>
              {index !== (campaigns.length - 1) ? (
                <hr style={hrStyle} />
              ) : null}
            </div>
          );
        })}
      </div>
      )}
    </div>
  );
};

export default CampaignsTab;
